import { render, staticRenderFns } from "./Editar.vue?vue&type=template&id=15f4f2d4"
import script from "./Editar.vue?vue&type=script&setup=true&lang=js"
export * from "./Editar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports